import {
  ApplicationStatus,
  ApplicationVisability,
  IApplication,
} from "../../models/Application/Application";
import { enumToSelectOptions } from "../../utils/enumToKeyValue";
import Card from "../shared/Card/Card";

interface ApplicationDetailsProps {
  application: IApplication;
}

export function ApplicationDetails({ application }: ApplicationDetailsProps) {
  return (
    <Card title="Basic Information">
      <dl className="px-4 divide-y divide-gray-100">
        <div className="grid grid-cols-1 md:grid-cols-3 py-2">
          <dt className="text-sm font-medium leading-6 text-gray-900">Name</dt>
          <dd className="mt-1 text-sm leading-6 text-gray-700 md:col-span-2 md:mt-0">
            {application.name}
          </dd>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 py-2">
          <dt className="text-sm font-medium leading-6 text-gray-900">
            System
          </dt>
          <dd className="mt-1 text-sm leading-6 text-gray-700 md:col-span-2 md:mt-0">
            {application.system ? "Yes" : "No"}
          </dd>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 py-2">
          <dt className="text-sm font-medium leading-6 text-gray-900">
            Allow Sign Up
          </dt>
          <dd className="mt-1 text-sm leading-6 text-gray-700 md:col-span-2 md:mt-0">
            {application.allowSignup ? "Yes" : "No"}
          </dd>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 py-2">
          <dt className="text-sm font-medium leading-6 text-gray-900">
            Status
          </dt>
          <dd className="mt-1 text-sm leading-6 text-gray-700 md:col-span-2 md:mt-0">
            {enumToSelectOptions(ApplicationStatus)[application.status].label}
          </dd>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 py-2">
          <dt className="text-sm font-medium leading-6 text-gray-900">
            Visability
          </dt>
          <dd className="mt-1 text-sm leading-6 text-gray-700 md:col-span-2 md:mt-0">
            {
              enumToSelectOptions(ApplicationVisability)[application.visability]
                .label
            }
          </dd>
        </div>
      </dl>
    </Card>
  );
}
